import { IBaseApiRequest } from '@api';
import { IPaginated, ISortable, IUser, PaginationMeta } from '@entities';
import { getSorterParamsForApi, insertIfObj } from '@functions';
import { AxiosResponse } from 'axios';

interface IGetAll extends IBaseApiRequest, IPaginated, ISortable {
  baasClientId: string;
  search: string;
}
export async function getAll({
  api,
  offset,
  limit,
  attribute,
  direction,
  search,
  baasClientId,
}: IGetAll) {
  let params = {
    offset,
    limit,
    ...insertIfObj(Boolean(search), {
      search,
    }),
    ...getSorterParamsForApi({ attribute, direction }),
  };

  let response = (await api.get(`platform/${baasClientId}/users`, {
    params,
  })) as AxiosResponse<{
    data: {
      data: IUser[];
      meta: PaginationMeta;
    };
  }>;

  return response.data.data;
}
